import { forwardRef, useImperativeHandle, useState } from 'react';
import { infraTypesById } from '../../statics/constants/infraTypes';
import {
  Combobox,
  ComboboxInput,
  ComboboxContent,
  ComboboxList,
  ComboboxItem,
  ComboboxEmpty,
} from '@hydrodigital/combobox';
import type { ComboboxOption } from '@hydrodigital/combobox';

interface SelectTypeInfrastructureProps {
	onSelect: (value: any) => void;
	emitObject?: boolean;
	defaultValue?: any;
	otherSettings?: any;
}

const items: ComboboxOption[] = Object.entries(infraTypesById).map(([key, value]) => ({
  value: key,
  label: value as string,
}));

const SelectTypeInfrastructure = forwardRef(
  (
    {
      onSelect,
      emitObject,
      defaultValue = undefined,
    }: SelectTypeInfrastructureProps,
    ref,
  ) => {
    const [selectedValue, setSelectedValue] = useState<string | undefined>(
      defaultValue !== null && defaultValue !== undefined
        ? String(defaultValue)
        : undefined,
    );

    useImperativeHandle(ref, () => ({
      setValue: (value: any) => {
        setSelectedValue(
          value !== null && value !== undefined ? String(value) : undefined,
        );
      },
    }));

    return (
      <Combobox
        items={items}
        value={selectedValue}
        onValueChange={(val) => {
          setSelectedValue(val);
          onSelect(emitObject ? JSON.parse(val || '{}') : val);
        }}
        onClear={() => {
          setSelectedValue(undefined);
          onSelect(null);
        }}
        size="small"
      >
        <ComboboxInput placeholder="Asset Type" />
        <ComboboxContent>
          <ComboboxEmpty>No types found.</ComboboxEmpty>
          <ComboboxList>
            {(item) => (
              <ComboboxItem key={item.value} value={item}>
                {item.label}
              </ComboboxItem>
            )}
          </ComboboxList>
        </ComboboxContent>
      </Combobox>
    );
  },
);

export default SelectTypeInfrastructure;
